import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { scenarioQueryKeys } from '../queryKeys'
import { jointScenarioQueryKeys } from '../../jointScenarios/queryKeys'
import { resourcefulScenarioRequest } from '../requests'

export function useCashflowEventsQuery({
  scenarioID,
  initialData,
  queryKey,
  additionalInvalidationKeys
}) {
  const queryClient = useQueryClient()

  const cashflowEventsRequests = resourcefulScenarioRequest(
    scenarioID, 'cashflow_events'
  )

  const cashflowEventsQuery = useQuery({
    queryFn: cashflowEventsRequests.index,
    queryKey,
    initialData
  })

  const invalidateQueries = async () => {
    await queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).forecasts] })
    queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).cashflowEvents] })
    queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.forecast] })
    additionalInvalidationKeys.forEach(key => {
      queryClient.invalidateQueries({ queryKey: [key] })
    })
  }

  const updateCashflowEventMutation = useMutation({
    mutationFn: cashflowEventsRequests.update,
    onSuccess: () => {
      invalidateQueries()
    },
  })

  const createCashflowEventMutation = useMutation({
    mutationFn: cashflowEventsRequests.create,
    onSuccess: () => {
      invalidateQueries()
    },
  })

  const deleteCashflowEventMutation = useMutation({
    mutationFn: cashflowEventsRequests.delete,
    onSuccess: () => {
      invalidateQueries()
    },
  })

  const isFetching = cashflowEventsQuery.isFetching || updateCashflowEventMutation.isLoading

  const isAnyLoading = cashflowEventsQuery.isFetching ||
    createCashflowEventMutation.isLoading ||
    updateCashflowEventMutation.isLoading ||
    deleteCashflowEventMutation.isLoading

  return {
    data: cashflowEventsQuery.data,
    actions: {
      update: updateCashflowEventMutation.mutateAsync,
      create: createCashflowEventMutation.mutateAsync,
      delete: deleteCashflowEventMutation.mutateAsync
    },
    status: cashflowEventsQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
